import gql from 'graphql-tag'

export const COMMISSION_SPLIT_UPDATE_MUTATION = gql`
    mutation commissionSplitUpdate(
        $id: ID!
        $commissionSplit: CommissionSplitInput!
    ) {
        commissionSplitUpdate(
            id: $id,
            commissionSplit: $commissionSplit
        ) {
            id,
            additionalRecipient {
                id,
                first_name,
                last_name
            }
            split_rate,
            active_from,
            active_until
            is_active
        }
    }
`
